import React, { useEffect } from 'react'
import GoalsPool from '../../js/GoalsPool';
import { GAME_STATES } from '../../js/ids';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import { store } from '../../stores/store';

import {FaFrown, FaTrophy} from "react-icons/fa"

import wingif from '../../images/win.gif'
import losegif from '../../images/lose.gif'

import './GameOverPopup.css'

const STATES = {
  VICTORY: "VICTORY",
  DEFEAT: "DEFEAT",
  DRAW: "DRAW",
}

const GameOverPopup = () => {

  function close() {
    window.top.postMessage("DEMO_END", "*");
    //PopupStore.close(POPUPS_IDS.GAME_OVER)
  }

  const finalGoals = (store.gameState === GAME_STATES.OVER_VICTORY) ?
    GoalsPool.validGoalsGroups.filter(gr => gr.isVictory) :
    GoalsPool.validGoalsGroups.filter(gr => !gr.isVictory)



  return (
    <div className="GameOverPopup-overlay" onClick={close}>
      <div className="GameOverPopup">
        <div className="GameOverPopup-top">
          {store.gameState === GAME_STATES.OVER_VICTORY && <span>{store.t("game_over_title_win")}</span>}
          {store.gameState === GAME_STATES.OVER_DEFEAT  && <span>{store.t("game_over_title_lose")}</span>}
          <div className="GameOverPopup-close" onClick={close} />
        </div>

        <div className="GameOverPopup-content">
          {store.gameState === GAME_STATES.OVER_VICTORY &&
          <div>
            <img src={wingif} alt="victory gif"/>
            <p>{store.t("game_over_win")}</p>
          </div>}

          {store.gameState === GAME_STATES.OVER_DEFEAT  &&
          <div>
            <img src={losegif} alt="defeat  gif"/>
            <p>{store.t("game_over_lose")}</p>
          </div>}

          <div className="goals">
          {finalGoals.map((group, index) => (
            <div key={index}>
              <ul className="goals-group">
                {group.goals.map(g => <li key={g.id}>{g.translated_title}</li>)}
              </ul>
            </div>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameOverPopup;
